{
  "version": 1,
  "asset_id": "5b69bfdb-8ee9-4c03-b650-7a46d3f1a989",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/5b69bfdb-8ee9-4c03-b650-7a46d3f1a989/g15.jpg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/5b69bfdb-8ee9-4c03-b650-7a46d3f1a989/g15.jpg",
  "original_filename": "g15.jpg",
  "size": 1551847,
  "content_type": "image/jpeg",
  "created_at": "2026-07-02T22:52:58Z"
}
